import { CarouselBanner } from "@alpacahq/ui/old";

import type { useHomeCarouselController } from "./HomeCarousel.controller";
import { fpslSlide } from "./slides/fpslSlide";
import { iraSlide } from "./slides/iraSlide";
import { optionsSlide } from "./slides/optionsSlide";

export type HomeCarouselPresentationProps = ReturnType<
  typeof useHomeCarouselController
>;

export const HomeCarouselPresentation = ({
  showOptionsSlide,
  showFpslSlide,
  showIraSlide,
  onApplyOptions,
  onEnrollFpsl,
  onApplyIra,
}: HomeCarouselPresentationProps) => {
  const slides = [
    ...(showOptionsSlide ? [optionsSlide({ onApply: onApplyOptions })] : []),
    ...(showFpslSlide ? [fpslSlide({ onEnroll: onEnrollFpsl })] : []),
    ...(showIraSlide ? [iraSlide({ onApply: onApplyIra })] : []),
  ];

  if (slides.length === 0) {
    return null;
  }

  return (
    <CarouselBanner
      slides={slides}
      autoPlay={true}
      autoPlayInterval={15000}
      className="shadow-none"
    />
  );
};
